import React from 'react'
import { Box, get } from '@ally/metronome-ui'
import styled from 'styled-components'
import { useWidget } from './WidgetContext'
import SavingsGrowthChart from './SavingsGrowthChart'
import SavingsGrowthTable from './SavingsGrowthTable'

export const StyledTextHeading = styled.h3`
  font-size: ${get.fontSizes('sm')};
`

const SavingsGrowthBreakdown: React.FC = () => {
  const { stkSummaryData } = useWidget()

  const showGrowthBreakdown =
    stkSummaryData?.hasGrowth && stkSummaryData?.growthChart.monthToDateSummary
  if (!showGrowthBreakdown) {
    return null
  }

  const currentMonth = stkSummaryData?.growthChart.monthToDateSummary?.monthFull
  return (
    <Box data-testid="boosters-growth-breakdown" flex="2 0 27%">
      <StyledTextHeading tabIndex={-1}>
        Growth Breakdown for {currentMonth}
      </StyledTextHeading>
      <Box display="flex" flexWrap="wrap" justifyContent="center">
        <SavingsGrowthChart />
        <SavingsGrowthTable />
      </Box>
    </Box>
  )
}

export default SavingsGrowthBreakdown
